import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import {isEmpty} from 'lodash';
import cx from 'classnames';
import {
    Checkbox
} from '@nike/ruxac';
import {diff} from 'deep-object-diff';
import _ from 'lodash';


class NikeReactTable extends Component {
    constructor(props) {
        super(props);

        this.instance = null;
        this.instanceState = null;

        this.checkboxColumn = (id) => {
            return (
                [
                    { show : false, Header : "index", accessor : id },
                    {
                        id       : "checkbox",
                        accessor : "",
                        Cell     : ({ original }) => {
                            return (
                                <Checkbox
                                    onChange={() => this.toggleRow(original[id])}
                                    value={this.state.selected[original[id]] === true}
                                />
                            );
                        },
                        Header : () => {
                            return (
                                <Checkbox
                                    onChange={() => this.toggleSelectAll()}
                                    value={this.state.selectAll === 1}
                                    className={cx({
                                        "checkbox-dashed" : (this.state.selectAll === 2)
                                    })}
                                    ref={input => {
                                        if (input) {
                                            input.indeterminate = this.state.selectAll === 2;
                                        }
                                    }}
                                />
                            );
                        },
                        sortable : false,
                        width    : 45
                    }
                ]
            );
        };

        this.state = {
            selected  : {},
            selectAll : 0
            // pageIndex  : 0,
            // pageSize   : this.props.defaultPageSize
        };

        this.toggleRow         = this.toggleRow.bind(this);
        this.currentPageIds    = this.currentPageIds.bind(this);
        this.onTableViewChange = this.onTableViewChange.bind(this);
        this.handleOnFetchData = this.handleOnFetchData.bind(this);

        //this.reactTable = React.createRef();
    }

    async shouldComponentUpdate(prevProps) {
        if (prevProps.loading === false && !_.isEmpty(diff(this.props.data, prevProps.data))) {
            this.setState({
                currentPageIds : await this.currentPageIds()
            });
            this.onTableViewChange(true, true);
        }

        if (
            !_.isEmpty(diff(this.props.data, prevProps.data)) ||
            !_.isEqual(this.props.loading, prevProps.loading) ||
            !_.isEqual(prevProps.page, this.props.page)
        ) {
            return true;
        }

        return false;
    }

    getSelectedIds(obj) {
        return Object.keys(obj).map(k => (obj[k] === true ? parseInt(k, 10) : null)).filter(v => (v !== null));
    }

    componentDidUpdate(prevProps, prevState) {
        if (typeof this.props.onCheckChange === "function") {

            const selectedIds     = this.getSelectedIds(this.state.selected);
            const prevSelectedIds = this.getSelectedIds(prevState.selected);
            const arrayDiff       = this.arrDiff(selectedIds, prevSelectedIds);

            if (arrayDiff.length) {
                this.props.onCheckChange(selectedIds, {
                    checked : (prevSelectedIds.length < selectedIds.length),
                    changed : arrayDiff
                });
            }
        }

        if(this.props.shouldClearSelected !== prevProps.shouldClearSelected) {
            if(this.props.shouldClearSelected && !isEmpty(this.state.selected)) {
                //console.log("Need to clear");
                this.setState({selected : {}});
            }
        }
    }

    handleOnFetchData(state, instance) {
        // if (this.instance) {
        //     return;
        // }
        this.instance = instance;
        this.instanceState = state;
    }

    arrDiff(a1, a2) {
        let a = [], diff = [];
        for (let i = 0; i < a1.length; i++) {
            a[a1[i]] = true;
        }

        for (let i = 0; i < a2.length; i++) {
            if (a[a2[i]]) {
                delete a[a2[i]];
            } else {
                a[a2[i]] = true;
            }
        }

        for (let k in a) {
            diff.push(parseInt(k, 10));
        }

        return diff;
    }

    toggleRow(id) {
        const newSelected = {...this.state.selected};
        newSelected[id] = !this.state.selected[id];
        const selectedIds = this.getSelectedIds(newSelected);
        this.setState({
            selected  : newSelected,
            selectAll : (selectedIds.length > 0 ? 2 : 0)
        });
    }

    async toggleSelectAll() {
        let newSelected = {};

        //if (this.props.selectAllType === "page") {
        newSelected = {...this.state.selected};
        const cd = await this.currentPageIds();
        if (this.state.selectAll === 0) {
            cd.forEach(x => {
                newSelected[x] = true;
            });
        } else {
            cd.forEach(x => {
                if (newSelected[x]) {
                    delete newSelected[x];
                }
            });
        }
        //}
        // else {
        // 	if (this.state.selectAll === 0) {
        // 		this.props.data.forEach(x => {
        // 			newSelected[x[this.props.id]] = true;
        // 		});
        // 	}
        // }

        this.setState({
            selected  : newSelected,
            selectAll : this.state.selectAll === 0 ? 1 : 0
        });
    }

    currentPageIds() {
        return new Promise((resolve) => {
            setTimeout(() => {
                const current = this.instance;
                if (current) {
                    const ids = [];
                    current.resolvedData.forEach(x => {
                        ids.push(x[this.props.id]);
                    });
                    resolve(ids);
                    return;
                }
                resolve([]);
            }, 0);
        });
        // const current = this.reactTable.current;
        // if (current) {
        //     const page = current.state.page;
        //     const pageSize = current.state.pageSize;
        //     const allData = current.getResolvedState().sortedData;
        //     const startIdx = page * pageSize;
        //     const currentData = allData.slice(startIdx, startIdx + pageSize).map((item) => item._original);
        //     const ids = [];
        //     currentData.forEach(x => {
        //         ids.push(x[this.props.id]);
        //     });
        //     return ids;
        // }
        // return [];
    }

    async onTableViewChange(manual, fetchData = false) {
        if(manual && !fetchData) {return;}

        const cd = await this.currentPageIds();
        let selectAllState = 0;
        let selectCount = 0;
        cd.forEach(x => {
            if (this.state.selected[x]) {
                selectCount++;
            }
        });
        if (selectCount > 0) {
            selectAllState = 2;
            if (selectCount === cd.length) {
                selectAllState = 1;
            }
        }

        this.setState({
            selectAll : selectAllState
            // pageIndex: this.reactTable.current.state.page,
            // pageSize: this.reactTable.current.state.pageSize
        });
    }

    render() {
        const columns = [...this.props.columns];
        if (this.props.checkboxAt !== undefined && this.props.checkboxAt >= 0) {
            columns.splice(this.props.checkboxAt, 0, ...this.checkboxColumn(this.props.id));
        }

        const newProps = {...this.props};

        // Remove overwritten props from newProps clone
        if (this.props.onFetchData && typeof this.props.onFetchData === 'function') { delete newProps['onFetchData']; }
        if (this.props.onPageChange && typeof this.props.onPageChange === 'function') { delete newProps['onPageChange']; }
        if (this.props.onPageSizeChange && typeof this.props.onPageSizeChange === 'function') { delete newProps['onPageSizeChange']; }
        if (this.props.onSortedChange && typeof this.props.onSortedChange === 'function') { delete newProps['onSortedChange']; }
        if (this.props.onExpandedChange && typeof this.props.onExpandedChange === 'function') { delete newProps['onExpandedChange']; }
        if (this.props.onFilteredChange && typeof this.props.onFilteredChange === 'function') { delete newProps['onFilteredChange']; }
        if (this.props.onResizedChange && typeof this.props.onResizedChange === 'function') { delete newProps['onResizedChange']; }
        // if (this.props.onPageChange && typeof this.props.onPageChange === 'function') { delete newProps['onPageChange']; }
        // if (this.props.onPageSizeChange && typeof this.props.onPageSizeChange === 'function') { delete newProps['onPageSizeChange']; }
        // if (this.props.onSortedChange && typeof this.props.onSortedChange === 'function') { delete newProps['onSortedChange']; }
        // if (this.props.onExpandedChange && typeof this.props.onExpandedChange === 'function') { delete newProps['onExpandedChange']; }
        // if (this.props.onFilteredChange && typeof this.props.onFilteredChange === 'function') { delete newProps['onFilteredChange']; }
        // if (this.props.onResizedChange && typeof this.props.onResizedChange === 'function') { delete newProps['onResizedChange']; }

        return (
            <ReactTable
                {...newProps}
                data={this.props.data}
                //ref={this.reactTable}
                columns={columns}
                onFetchData={(state, instance) => {
                    if (this.props.onFetchData && typeof this.props.onFetchData === 'function') {
                        this.props.onFetchData(state, instance);
                        this.onTableViewChange(this.props.manual, true);
                    } else {
                        this.onTableViewChange(this.props.manual);
                    }
                    this.handleOnFetchData(state, instance);
                }}
                onPageChange={(pageIndex) => {
                    if (this.props.onPageChange && typeof this.props.onPageChange === 'function') { this.props.onPageChange(pageIndex); }
                    this.onTableViewChange(this.props.manual);
                }}
                onPageSizeChange={(pageSize, pageIndex) => {
                    if (this.props.onPageSizeChange && typeof this.props.onPageSizeChange === 'function') { this.props.onPageSizeChange(pageSize, pageIndex); }
                    this.onTableViewChange(this.props.manual);
                }}
                onSortedChange={(newSorted, column, shiftKey) => {
                    if (this.props.onSortedChange && typeof this.props.onSortedChange === 'function') { this.props.onSortedChange(newSorted, column, shiftKey); }
                    this.onTableViewChange(this.props.manual);
                }}
                onExpandedChange={(newExpanded, index, event) => {
                    if (this.props.onExpandedChange && typeof this.props.onExpandedChange === 'function') { this.props.onExpandedChange(newExpanded, index, event); }
                    this.onTableViewChange(this.props.manual);
                }}
                onFilteredChange={(filtered, column) => {
                    if (this.props.onFilteredChange && typeof this.props.onFilteredChange === 'function') { this.props.onFilteredChange(filtered, column); }
                    this.onTableViewChange(this.props.manual);
                }}
                onResizedChange={(newResized, event) => {
                    if (this.props.onResizedChange && typeof this.props.onResizedChange === 'function') { this.props.onResizedChange(newResized, event); }
                    this.onTableViewChange(this.props.manual);
                }}
            />
        );
    }
}

NikeReactTable.propTypes = {
    onCheckChange    : PropTypes.func,
    data             : PropTypes.array.isRequired,
    loading          : PropTypes.bool,
    page             : PropTypes.number,
    id               : PropTypes.string,
    columns          : PropTypes.array,
    checkboxAt       : PropTypes.number,
    onPageChange     : PropTypes.func,
    onPageSizeChange : PropTypes.func,
    onSortedChange   : PropTypes.func,
    onExpandedChange : PropTypes.func,
    onFilteredChange : PropTypes.func,
    onResizedChange  : PropTypes.func,
    onFetchData      : PropTypes.func,
    manual           : PropTypes.bool
};

export default NikeReactTable;


// WEBPACK FOOTER //
// ./src/Components/NikeReactTable.js